import "./style/Coaches.css";
import PopupForm from "./PopupForm/PopupForm";
import DeletePopup from "./PopupForm/DeletePopup";
import { useEffect, useState } from "react";
import { GrView } from "react-icons/gr";

import { FaUserFriends } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { MdRestore } from "react-icons/md";
import { Link } from "react-router-dom";
import Paginations from "./Paginations";
import debounce from "lodash.debounce";

import { isAuthenticated } from "../apicalls/auth";
import { getAllCoaches, getTotalCoaches, restoreCoach } from "../apicalls/coaches";

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return "-";
  }

  return `$${amount.toFixed(2)}`;
};

const formatPackageRate = (coach) => {
  const rates = coach?.package_rates;
  if (!rates || !rates.has_active_packages) {
    return "No active packages";
  }

  if (rates.min_rate_per_lesson === rates.max_rate_per_lesson) {
    return `${formatCurrency(rates.min_rate_per_lesson)} / lesson`;
  }

  return `${formatCurrency(rates.min_rate_per_lesson)} - ${formatCurrency(
    rates.max_rate_per_lesson
  )} / lesson`;
};

const formatLocationStatus = (coach) => {
  const locationSearch = coach?.location_search;
  if (!locationSearch) {
    return "Unknown";
  }

  if (locationSearch.appears_in_nearby_discovery) {
    return "Shows in nearby";
  }

  if (locationSearch.appears_in_location_search) {
    return "Location only";
  }

  return "Needs fix";
};

function Coaches() {
  const [temp, setTemp] = useState([]);
  const [addpopup, setaddPopup] = useState(false);
  const [editpopup, seteditPopup] = useState(false);
  const [deletepopup, setdeletePopup] = useState(false);
  const [coaches, setCoaches] = useState([]);
  const [total, setTotal] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [coachPerPage, setCoachPerPage] = useState(10);
  const [refreshKey, setRefreshKey] = useState(0);
  const [restoringCoachId, setRestoringCoachId] = useState(null);

  const user = isAuthenticated();
  const accessToken = user?.access_token;

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    getAllCoaches(coachPerPage, currentPage, search, accessToken).then(
      (data) => {
        setCoaches(data);
      }
    );

    getTotalCoaches(accessToken).then((data) => {
      setTotal(data);
      let temp2 = [];
      for (let i = currentPage; i <= Math.ceil(data?.length / 10); i++) {
        temp2.push(i * 10);
      }
      setTemp(temp2);
    });
  }, [addpopup, editpopup, deletepopup, refreshKey, search, coachPerPage, currentPage, accessToken]);

  // const indexOfLastCoach = currentPage * coachPerPage;
  // const indexOfFirstCoach = indexOfLastCoach - coachPerPage;
  // const currentCoaches =
  //   coaches?.length > 0
  //     ? coaches?.slice(indexOfFirstCoach, indexOfLastCoach)
  //     : coaches;

  const paginate = (number) => {
    setCurrentPage(number);
  };

  const handleChange = (e) => {
    setCoachPerPage(e.target.value);
  };

  const handleSearch = (e) => {
    setSearch(e?.target?.value);
  };

  const deBounceOnChange = debounce(handleSearch, 500);

  const handleRestore = async (coach) => {
    const confirmed = window.confirm(`Restore ${coach.full_name}?`);
    if (!confirmed || !accessToken) {
      return;
    }

    setRestoringCoachId(coach.id);
    const restored = await restoreCoach(coach.id, accessToken);
    setRestoringCoachId(null);

    if (restored?.detail || restored?.details) {
      window.alert(restored.detail || restored.details);
      return;
    }

    setRefreshKey((value) => value + 1);
  };

  return (
    <main>
      <div className="coaches_title">
        <h1>Coaches</h1>
        <button
          className="coaches_button"
          onClick={() => {
            setaddPopup(true);
          }}
        >
          Add Coach +
        </button>
      </div>
      {addpopup && (
        <PopupForm action="Add" person="Coaches" setPopup={setaddPopup} />
      )}
      <div className="filter">
        {currentPage > 1 ? (
          ""
        ) : (
          <div>
            <select name="" id="" onChange={handleChange}>
              {temp?.map((val) => {
                return (
                  <option key={val} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
            <span>
              show {coachPerPage} out of {total?.length}
            </span>
          </div>
        )}
        <input
          className="w-25"
          type="text"
          onChange={deBounceOnChange}
          placeholder="Search"
        />
      </div>

      <div className="col-11">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone no.</th>
                <th scope="col">Locations</th>
                <th scope="col">Packages</th>
                <th scope="col">View</th>
                <th scope="col">View players</th>
                <th scope="col">Edit</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {coaches?.length > 0 ? (
                coaches?.map((coach) => {
                  return (
                    <tr key={coach.id}>
                      <td className="fw-bold">
                        <img
                          src={coach.profile_picture}
                          alt=""
                          id="table_img"
                        />{" "}
                        {coach.full_name}{" "}
                        <span className="text-danger fw-normal">
                          {coach.is_deleted ? " ( deleted coach )" : ""}
                        </span>
                      </td>
                      <td>{coach.email}</td>
                      <td>{coach.phone}</td>
                      <td>
                        <span
                          className={
                            coach?.location_search?.appears_in_nearby_discovery
                              ? "success fw-bold"
                              : "error fw-bold"
                          }
                        >
                          {formatLocationStatus(coach)}
                        </span>
                        <div style={{ fontSize: "12px" }}>
                          {coach?.location_search?.searchable_location_count || 0}/
                          {coach?.location_search?.location_count || 0} valid,
                          {" "}
                          {coach?.location_search?.scheduled_location_count || 0} scheduled
                        </div>
                        {coach?.location_search?.issues?.length ? (
                          <div className="text-danger" style={{ fontSize: "12px" }}>
                            {coach.location_search.issues.join(", ")}
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        <span className="fw-bold">{formatPackageRate(coach)}</span>
                        <div style={{ fontSize: "12px" }}>
                          {coach?.package_rates?.active_package_count || 0} active /{" "}
                          {coach?.package_rates?.package_count || 0} total
                        </div>
                      </td>
                      <td>
                        <Link to={`/view/${coach.user_id}`}>
                          <GrView />
                        </Link>
                        
                      </td>
                      <td>
                      <Link to={`/coachplayers/${coach.user_id}`}>
                          <FaUserFriends />
                        </Link>
                        
                      </td>
                      <td>
                        <FiEdit
                          className="icon-cursor"
                          onClick={() => {
                            seteditPopup(coach.id);
                          }}
                        />
                        {editpopup === coach.id && (
                          <PopupForm
                            coach_id={coach.id}
                            action="Edit"
                            person="Coaches"
                            setPopup={seteditPopup}
                          />
                        )}
                      </td>
                      <td>
                        {!coach.is_deleted ? (
                          <>
                          <AiOutlineDelete
                            className="icon-cursor"
                            title="Delete coach"
                            onClick={() => {
                              setdeletePopup(coach.id);
                            }}
                          />
                          {deletepopup === coach.id && (
                            <DeletePopup
                              coach_id={coach.id}
                              setPopup={setdeletePopup}
                            />
                          )}
                          </>
                        ) : (
                          <button
                            className="btn btn-sm btn-outline-success"
                            disabled={restoringCoachId === coach.id}
                            title="Restore coach"
                            onClick={() => handleRestore(coach)}
                          >
                            <MdRestore />{" "}
                            {restoringCoachId === coach.id ? "Restoring" : "Restore"}
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td>
                    <h2>Coaches not Available</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {search ? (
          ""
        ) : (
          <Paginations
            perPage={coachPerPage}
            total={total?.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        )}
      </div>
    </main>
  );
}

export default Coaches;
